import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

const ANONYMOUS_CATALOG_LOCALE: ViewerLocale = "pt";
const NEUTRAL_CATALOG_PATH = /^\/(?:artist|company|release|work)(?:\/|$)|^\/search(?:\/|$)/;

export function resolveRouteDisplayLocale(input: {
  pathname: string;
  preferredLocale: ViewerLocale;
  routeLocale: ViewerLocale | null;
  isMember: boolean;
}): ViewerLocale {
  if (input.routeLocale) return input.routeLocale;
  if (!input.isMember && NEUTRAL_CATALOG_PATH.test(input.pathname)) {
    return ANONYMOUS_CATALOG_LOCALE;
  }
  return input.preferredLocale;
}
